module.exports = __webpack_public_path__ + "static/media/sell_resend_invoice_1.6c69f369.jpg";